import React from "react"

function IndeterminateCheckbox({ indeterminate, className = "", disabled = false, onChange, ...rest }) {
  const ref = React.useRef(null)

  React.useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [ref, indeterminate])

  return (
    <label className="kt-checkbox">
      <input
        type="checkbox"
        ref={ref}
        className={className + " cursor-pointer form-control"}
        disabled={disabled}
        onChange={onChange}
        {...rest}
      />
      <span></span>
    </label>
  )
}

export default IndeterminateCheckbox
